import { memo } from "react";

function NewPickUpIcon(props) {
  const { borderColor="white", size = 27, backgroundColor = "#E5A70D" } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
        fill={backgroundColor}
      />
      <path
        d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
        stroke={borderColor}
      />
      <path
        d="M6.38776 19.9796C6.0068 19.9796 5.68027 19.8401 5.40816 19.5612C5.13605 19.2823 5 18.9592 5 18.5918V6.42857C5 6.04762 5.13605 5.72109 5.40816 5.44898C5.68027 5.17687 6.0068 5.04082 6.38776 5.04082H13.8776C14.0816 5.04082 14.2483 5.10884 14.3776 5.2449C14.5068 5.38095 14.5714 5.54422 14.5714 5.73469C14.5714 5.93878 14.5068 6.10544 14.3776 6.23469C14.2483 6.36395 14.0816 6.42857 13.8776 6.42857H6.38776V18.5918H18.551V11.1224C18.551 10.9184 18.619 10.7517 18.7551 10.6224C18.8912 10.4932 19.0544 10.4286 19.2449 10.4286C19.449 10.4286 19.6156 10.4932 19.7449 10.6224C19.8742 10.7517 19.9388 10.9184 19.9388 11.1224V18.5918C19.9388 18.9592 19.7993 19.2823 19.5204 19.5612C19.2415 19.8401 18.9184 19.9796 18.551 19.9796H6.38776ZM17.6531 9.69388C17.4626 9.69388 17.3095 9.63265 17.1939 9.5102C17.0782 9.38775 17.0204 9.2381 17.0204 9.06122V7.97959H15.9388C15.7619 7.97959 15.6122 7.91837 15.4898 7.79592C15.3673 7.67347 15.3061 7.52381 15.3061 7.34694C15.3061 7.15646 15.3673 7 15.4898 6.87755C15.6122 6.7551 15.7619 6.69388 15.9388 6.69388H17.0204V5.63265C17.0204 5.45578 17.0816 5.30612 17.2041 5.18367C17.3265 5.06122 17.4762 5 17.6531 5C17.8435 5 18 5.06122 18.1224 5.18367C18.2449 5.30612 18.3061 5.45578 18.3061 5.63265V6.69388H19.3673C19.5442 6.69388 19.6939 6.7551 19.8163 6.87755C19.9388 7 20 7.15646 20 7.34694C20 7.53742 19.9388 7.69048 19.8163 7.80612C19.6939 7.92177 19.5442 7.97959 19.3673 7.97959H18.3061V9.06122C18.3061 9.2381 18.2415 9.38775 18.1122 9.5102C17.983 9.63265 17.8299 9.69388 17.6531 9.69388ZM6.38776 10.9184V18.5918V6.42857V10.9184Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(NewPickUpIcon);
